import { z } from 'zod'
import effects from 'app/effects/effects'

const creditsResponseSchema = z.object({
  credits: z.number(),
})

export async function getCreditsRequest(cancellableRef) {
  return creditsResponseSchema.parse(
    await effects.apis.credits.get({
      signal: cancellableRef.current.signal,
    }),
  )
}

const tokenResponseSchema = z.object({
  request_id: z.string(),
})

export async function getRequestId(cancellableRef) {
  return tokenResponseSchema.parse(
    await effects.apis.ai.token({
      signal: cancellableRef ? cancellableRef.current.signal : undefined,
    }),
  )
}
